import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import IyLayout from '@/layout/IyLayout'
import IyDataLayout from '@/layout/IyDataLayout'

/* Router Modules */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
    name: 'login'
  },
  // {
  //   path: '/404',
  //   component: () => import('@/views/error-page/404'),
  //   hidden: true
  // },
  // {
  //   path: '/401',
  //   component: () => import('@/views/error-page/401'),
  //   hidden: true
  // },
  {
    path: '/',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/home'),
        name: 'home'
      }
    ]
  },
  {
    path: '/star',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'star',
        props: true,
        component: () => import('@/views/star'),
        meta: { perm: 'tuibo' }
      },
      {
        path: 'history',
        component: () => import('@/views/star/history'),
        name: 'star-history',
        meta: { perm: 'tuibo' }
      }
    ]
  },
  {
    path: '/message',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'message',
        props: true,
        component: () => import('@/views/message'),
        meta: { perm: 'tuibo' }
      },
      {
        path: 'history',
        component: () => import('@/views/message/history'),
        name: 'message-history',
        meta: { perm: 'tuibo' }
      }
    ]
  },
  {
    path: '/song-list',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'songList',
        props: true,
        component: () => import('@/views/song-list'),
        meta: { perm: 'tuibo' }
      },
      {
        path: 'history',
        component: () => import('@/views/song-list/history'),
        name: 'songList-history',
        meta: { perm: 'tuibo' }
      }
    ]
  },
  {
    path: '/teach',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'teach',
        props: true,
        component: () => import('@/views/teach'),
        meta: { perm: 'tuibo' }
      },
      {
        path: 'history',
        component: () => import('@/views/teach/history'),
        name: 'teach-history',
        meta: { perm: 'tuibo' }
      }
    ]
  },
  {
    path: '/phone-banner',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'phoneBanner',
        props: true,
        component: () => import('@/views/phone-banner'),
        meta: { perm: 'tuibo' }
      },
      {
        path: 'history',
        component: () => import('@/views/phone-banner/history'),
        name: 'phoneBanner-history',
        meta: { perm: 'tuibo' }
      }
    ]
  },
  {
    path: '/system-log',
    component: IyLayout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'systemLog',
        component: () => import('@/views/home/Log'),
        meta: { perm: 'tuibo' }
      }
    ]
  },
  {
    path: '/device/mobile', // 移动机
    component: IyDataLayout,
    meta: {
      title: 'mobile-device',
      icon: 'mobile'
    },
    alwaysShow: false,
    children: [
      {
        path: '',
        component: () => import('@/views/device'),
        name: 'mobile-device-list',
        props: { model: 'N5_mobile' },
        meta: {
          title: 'mobile-device-list',
          perm: ['register', 'data']
        }
      },
      {
        path: 'statistics',
        hidden: true,
        component: () => import('@/views/device/Statistics'),
        name: 'mobile-device-statistics',
        props: { model: 'N5_mobile' },
        meta: {
          title: 'mobile-device-statistics',
          perm: ['register', 'data']
        }
      },
      {
        path: ':id',
        component: () => import('@/views/device/DeviceDetail'),
        name: 'mobile-device-detail',
        hidden: true,
        props: route => ({
          id: route.params.id,
          model: 'N5_mobile'
        }),
        meta: {
          activeMenu: '/device/mobile',
          perm: ['register', 'data']
        }
      }
    ]
  },
  {
    path: '/device/desk', // 桌机
    component: IyDataLayout,
    meta: {
      title: 'desk-device',
      icon: 'desktop'
    },
    alwaysShow: false,
    children: [
      {
        path: '',
        component: () => import('@/views/device'),
        name: 'desk-device-list',
        props: { model: 'N5_desk' },
        meta: {
          title: 'desk-device-list',
          perm: ['register', 'data']
        }
      },
      {
        path: 'statistics',
        hidden: true,
        component: () => import('@/views/device/Statistics'),
        name: 'desk-device-statistics',
        props: route => ({
          id: route.params.id,
          model: 'N5_desk'
        }),
        meta: {
          title: 'desk-device-statistics',
          perm: ['register', 'data']
        }
      },
      {
        path: ':id',
        hidden: true,
        component: () => import('@/views/device/DeviceDetail'),
        name: 'desk-device-detail',
        props: true,
        meta: {
          activeMenu: '/device/desk',
          perm: ['register', 'data']
        }
      }
    ]
  },
  {
    path: '/app',
    component: IyDataLayout,
    meta: { title: 'app-user' },
    alwaysShow: false,
    children: [
      {
        path: 'user',
        component: () => import('@/views/phone-app/User'),
        name: 'app-user-list',
        meta: {
          title: 'app-user-list',
          icon: 'phone',
          perm: ['register', 'data']
        }
      },
      {
        path: 'user/:id',
        hidden: true,
        component: () => import('@/views/phone-app/UserDetail'),
        name: 'app-user-detail',
        props: true,
        meta: {
          activeMenu: '/app/user',
          perm: ['register', 'data']
        }
      }
    ]
  },
  {
    path: '/hot-song',
    component: IyDataLayout,
    meta: {
      title: 'hot-song',
      icon: 'music'
    },
    alwaysShow: true,
    children: [
      {
        path: '',
        component: () => import('@/views/hot-song'),
        name: 'hot-song-list',
        meta: {
          title: 'hot-song-list',
          perm: ['data']
        }
      },
      {
        path: 'click',
        component: () => import('@/views/hot-song/click'),
        name: 'hot-song-click',
        meta: {
          title: 'hot-song-click',
          perm: ['data']
        }
      }
    ]
  },
  {
    path: '/loginlog',
    component: IyDataLayout,
    meta: { title: 'loginlog' },
    alwaysShow: false,
    children: [
      {
        path: 'loginlog',
        component: () => import('@/views/loginlog'),
        name: 'loginlog',
        meta: {
          title: 'loginlog',
          icon: 'login',
          perm: ['register', 'data']
        }
      }
    ]
  }
  // {
  //   path: '/yt-failed',
  //   component: IyDataLayout,
  //   meta: { title: 'yt-failed' },
  //   alwaysShow: false,
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/yt-failed/index'),
  //       name: 'yt-failed',
  //       meta: {
  //         title: 'yt-failed',
  //         perm: ['data']
  //       }
  //     }
  //   ]
  // }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
